import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  FormControl,
  FormGroup,
  Grid,
  Icon,
  Paper,
  Toolbar,
} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { Select } from "antd";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { getData } from "../../api/apiCaller";
import Dialog from "../../components/Dialog";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps as agentAction } from "./../../redux/agent";
import { mapActionsToProps as phoneNumberAction } from "./../../redux/cloudPBX/phoneNumber";
import { mapActionsToProps } from "./../../redux/dashboard";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
  },
  form: {
    width: "100%",
  },
});

class ReportCallOutput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        from: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD"),
        to: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD"),
        contactCode: "tct",
        cityCode: null,
        subOrg: null,
      },
      loading: false,
      timeTo: null,
      timeFrom: null,
      listCities: null,
      listSubOrgs: null,
      careOutputs: null,
      isFilterSubOrg: false,
      showCityFrom: true,
    };
  }

  async componentDidMount() {
    const { filters } = this.state;
    this.history = globalHistory();
    this.props.dashboardContact();
    this.callApiGetCities();
    // this.callApiGetCTCenter();
    this.callApiReportCareOutput(filters);
  }

  async callApiGetCities(name = null, limit) {
    const where = {
      ...(name && { name: { like: name, options: "i" } }),
    };
    const { data } = await getData("/vnpost/city-post-office", {
      filter: { where, limit },
    });
    this.setState({ listCities: data });
  }

  async callApiGetCTCenter(name = null, limit) {
    const where = {
      ...(name && { name: { like: name, options: "i" } }),
    };
    const { data } = await getData("/vnpost/contact-center", {
      filter: { where, limit },
    });
    this.setState({ contactCenters: data });
  }

  async callApiReportCareOutput(dataFillter = {}) {
    this.setState({ loading: true });
    const { data } = await getData(
      "/cloud-pbx/inbound-call/report-care-output",
      dataFillter
    );
    this.setState({ loading: false });
    this.setState({ careOutputs: data });
  }

  async callApiGetSubOrgs(citycode, districtcode, limit) {
    const where = {
      ...(citycode && !districtcode && { citycode }),
      ...(districtcode && { districtcode }),
      fullname: { $neq: null },
    };
    const { data } = await getData("/vnpost/province", {
      filter: { where, limit },
    });
    this.setState({ listSubOrgs: data });
  }

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters[name] = value;
    this.setState({ filters });
  };

  handleSubmit = (e) => {
    const { filters } = this.state;
    this.setState({ disable: false });
    const { cityCode = null } = filters || {};
    this.setState({ showCityFrom: cityCode ? false : true });
    this.callApiReportCareOutput(filters);
  };

  _export;
  export = async () => {
    const { filters } = this.state;
    await this.callApiReportCareOutput(filters);
    this._export.save();
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    const { filters } = this.state;
    filters[name] = value;
    this.setState({ filters: filters });
  };

  onChangeFilters(name, value) {
    const { contacts = [] } = this.props;
    const { filters } = this.state;
    filters[name] = value;

    if (name == "contactCode" && value != "tct") {
      const contact = contacts.find((item) => item.code == value) || {};
      const cityCodeFilter = contact.cityCode || null;
      this.callApiGetSubOrgs(cityCodeFilter);
      this.setState({ isFilterSubOrg: true });
    }

    if (name == "contactCode" && value == "tct") {
      this.setState({ isFilterSubOrg: false });
    }
    if (name == "contactCode") {
      filters["cityCode"] = null;
      filters["subOrg"] = null;
    }
    this.setState({ filters: filters });
  }

  render() {
    const { classes, contacts } = this.props;
    const {
      filters,
      listCities,
      careOutputs,
      loading,
      showCityFrom,
      isFilterSubOrg,
      listSubOrgs,
    } = this.state;

    const fieldKeyObject = showCityFrom ? "citycode" : "code";
    const careOutputObject = {};
    const contactFilter =
      (contacts || []).find((item) => item.code == filters.contactCode) || {};
    const contactName = contactFilter.name || null;

    (careOutputs || []).map((item, index) => {
      const proviceFrom = item.proviceFrom || {};
      let codeField = proviceFrom[fieldKeyObject] || null;

      if (item.dialMode != "transfer") {
        codeField = "dialModeNotTransfer";
      }

      const countStatus = careOutputObject[codeField]
        ? careOutputObject[codeField].countStatus
        : {
            missed: 0,
            answered: 0,
            "no-answered": 0,
            "skip-rejected": 0,
            "pending-rejected": 0,
            rejected: 0,
            ivr: 0,
            failed: 0,
            total: 0,
          };

      careOutputObject[codeField] = careOutputObject[codeField] || { ...item };
      countStatus["missed"] += item.countStatus["missed"];
      countStatus["answered"] += item.countStatus["answered"];
      countStatus["no-answered"] += item.countStatus["no-answered"];
      countStatus["skip-rejected"] += item.countStatus["skip-rejected"];
      countStatus["pending-rejected"] += item.countStatus["pending-rejected"];
      countStatus["rejected"] += item.countStatus["rejected"];
      countStatus["ivr"] += item.countStatus["ivr"];
      countStatus["failed"] += item.countStatus["failed"];
      countStatus["total"] += item.countStatus["total"];
      careOutputObject[codeField].countStatus = countStatus;
    });

    const totalST = {
      total: 0,
      answered: 0,
      missed: 0,
      rejected: 0,
      ivr: 0,
    };
    let dataExport = [];

    Object.keys(careOutputObject).map((key, index) => {
      const item = careOutputObject[key];
      const {
        total = 0,
        answered = 0,
        missed = 0,
        rejected = 0,
        ivr = 0,
      } = item.countStatus || {};
      totalST["total"] += total;
      totalST["answered"] += answered;
      totalST["no-answered"] += item.countStatus["no-answered"];
      totalST["skip-rejected"] += item.countStatus["skip-rejected"];
      totalST["pending-rejected"] += item.countStatus["pending-rejected"];
      totalST["failed"] += item.countStatus["failed"];
      totalST["missed"] += missed;
      totalST["rejected"] += rejected;
      totalST["ivr"] += ivr;

      const proviceFrom = item.proviceFrom || {};

      item.fromName = `${proviceFrom.citycode || ""} - ${
        proviceFrom.fullname || proviceFrom.name
      }`;
      if (showCityFrom) {
        item.fromName = `${proviceFrom.citycode || ""} - ${
          proviceFrom.address || ""
        }`;
      }
      if (key == "dialModeNotTransfer") {
        item.fromName = contactName || "-";
      }
      if (item.fromName.replace(/\s/g, "") == "-") {
        item.fromName = "Không có lịch sử";
      }

      dataExport.push({
        rowNumber: index + 1,
        contactName: contactName || "",
        subOrgName: item.subOrgName,
        subOrgFromName: item.subOrgFromName,
        fromName: item.fromName,
        total: total,
        answered: answered,
        missed: missed,
        rejected: rejected,
        ivr: ivr,
        asr: ((answered / total) * 100 || 0).toFixed(2),
        msr: ((missed / total) * 100 || 0).toFixed(2),
      });
    });

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item md={4} className="flexGridCareReport">
                        <div
                          className="autocomplete-list-phone-number__container"
                          style={{ marginTop: 18 }}>
                          <label className="autocomplete-list-phone-number__label">
                            Đơn vị tiếp nhận
                          </label>
                          <Select
                            showSearch
                            placeholder="Tất cả"
                            optionFilterProp="children"
                            value={this.state.filters.contactCode}
                            className="autocomplete-list-phone-number__select"
                            popupClassName="autocomplete-list-phone-number__dropdown"
                            onChange={this.onChangeFilters.bind(
                              this,
                              "contactCode"
                            )}
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={[
                              ...(contacts || []).map((d) => ({
                                value: d.code,
                                label: d.name,
                              })),
                            ]}
                          />
                        </div>
                      </Grid>

                      {!isFilterSubOrg ? (
                        <Grid item md={4} className="flexGridCareReport">
                          <div
                            className="autocomplete-list-phone-number__container"
                            style={{ marginTop: 18 }}>
                            <label className="autocomplete-list-phone-number__label">
                              Đơn vị chuyển tiếp cuộc gọi
                            </label>
                            <Select
                              showSearch
                              placeholder="Tất cả"
                              optionFilterProp="children"
                              className="autocomplete-list-phone-number__select"
                              popupClassName="autocomplete-list-phone-number__dropdown"
                              value={this.state.filters.cityCode}
                              onChange={this.onChangeFilters.bind(
                                this,
                                "cityCode"
                              )}
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={[
                                { value: null, label: "Tất cả" },
                                ...(listCities || []).map((d) => ({
                                  value: d.code,
                                  label: `${d.code} - ${d.name}`,
                                })),
                              ]}
                            />
                          </div>
                        </Grid>
                      ) : (
                        <Grid item md={4} className="flexGridCareReport">
                          <div
                            className="autocomplete-list-phone-number__container"
                            style={{ marginTop: 18 }}>
                            <label className="autocomplete-list-phone-number__label">
                              Đơn vị chuyển tiếp cuộc gọi
                            </label>
                            <Select
                              showSearch
                              placeholder="Tất cả"
                              optionFilterProp="children"
                              className="autocomplete-list-phone-number__select"
                              popupClassName="autocomplete-list-phone-number__dropdown"
                              value={this.state.filters.subOrg}
                              onChange={this.onChangeFilters.bind(
                                this,
                                "subOrg"
                              )}
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={[
                                { value: null, label: "Tất cả" },
                                ...(listSubOrgs || []).map((d) => ({
                                  value: d.code,
                                  label: `${d.fullname || d.name}`,
                                })),
                              ]}
                            />
                          </div>
                        </Grid>
                      )}

                      <Grid item md={4}>
                        <InlineDatePicker
                          margin="normal"
                          label="Từ ngày"
                          variant="outlined"
                          className={classes.input}
                          value={filters.from}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeStart}
                          name="from"
                          validators={["required"]}
                          errorMessages={[`Không được để trống`]}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <InlineDatePicker
                          margin="normal"
                          label="Đến ngày"
                          variant="outlined"
                          className={classes.input}
                          value={filters.to}
                          maxDate={new Date()}
                          minDate={filters.from}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeEnd}
                          invalidDateMessage="Định dạng Ngày không đúng"
                          maxDateMessage="Ngày lớn hơn ngày tối đa"
                          minDateMessage="Ngày nhỏ hơn ngày tối thiểu"
                          name="to"
                          validators={["required"]}
                          errorMessages={[`Không được để trống`]}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            style={{ marginLeft: "15px", marginTop: "15px" }}
                            className={classes.fab}
                            // onClick={this.handleSubmit}
                            type="submit">
                            <Search />
                          </Fab>
                        </Tooltip>
                        <Tooltip title="Tải báo cáo" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            style={{ marginLeft: "15px", marginTop: "15px" }}
                            className={classes.fab}
                            onClick={this.export}>
                            <Icon className={classes.add}>save_alt</Icon>
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
                <ExcelExport
                  data={dataExport}
                  ref={(exporter) => (this._export = exporter)}
                  fileName="Báo cáo sản lượng phục vụ.xlsx">
                  <ExcelExportColumn
                    field="rowNumber"
                    title="STT"
                    locked={true}
                    width={50}
                  />
                  <ExcelExportColumn
                    field="contactName"
                    title="Đơn vị tiếp nhận"
                    locked={true}
                    width={150}
                  />
                  <ExcelExportColumn
                    field="fromName"
                    title="Đơn vị chuyển tiếp cuộc gọi"
                    locked={true}
                    width={150}
                  />
                  <ExcelExportColumn
                    field="total"
                    title="Tổng cuộc gọi"
                    width={80}
                  />
                  <ExcelExportColumn
                    field="answered"
                    title="Trả lời"
                    width={80}
                  />
                  <ExcelExportColumn field="missed" title="Nhỡ" width={80} />
                  <ExcelExportColumn
                    field="rejected"
                    title="Từ chối"
                    width={80}
                  />
                  <ExcelExportColumn
                    field="asr"
                    title="Tỉ lệ trả lời"
                    width={80}
                  />
                  <ExcelExportColumn field="msr" title="Tỉ lệ nhỡ" width={80} />
                </ExcelExport>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>

        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>STT</TableCell>
                <TableCell>Đơn vị tiếp nhận</TableCell>
                <TableCell>Đơn vị chuyển tiếp cuộc gọi</TableCell>
                <TableCell>Tổng</TableCell>
                <TableCell>Trả lời</TableCell>
                <TableCell>Nhỡ</TableCell>
                <TableCell>Từ chối</TableCell>
                <TableCell>Tỉ lệ trả lời</TableCell>
                <TableCell>Tỉ lệ nhỡ</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow style={{ whiteSpace: "nowrap" }}>
                <TableCell component="th" scope="row">
                  <b>000</b>
                </TableCell>
                <TableCell component="th" scope="row">
                  <b>Tổng số</b>
                </TableCell>
                <TableCell component="th" scope="row"></TableCell>
                <TableCell component="th" scope="row">
                  <b>{totalST.total}</b>
                </TableCell>
                <TableCell component="th" scope="row">
                  <b>{totalST.answered}</b>
                </TableCell>
                <TableCell component="th" scope="row">
                  <b>{totalST.missed}</b>
                </TableCell>
                <TableCell component="th" scope="row">
                  <b>{totalST.rejected}</b>
                </TableCell>
                <TableCell component="th" scope="row">
                  <Toolbar title="Tỉ lệ trả lời">
                    <b>{`${(
                      (totalST.answered / totalST.total) * 100 || 0
                    ).toFixed(2)}%`}</b>
                  </Toolbar>
                </TableCell>
                <TableCell component="th" scope="row">
                  <Toolbar title="Tỉ lệ nhỡ">
                    <b>{`${(
                      (totalST.missed / totalST.total) * 100 || 0
                    ).toFixed(2)}%`}</b>
                  </Toolbar>
                </TableCell>
              </TableRow>

              {(dataExport || []).map((row, key) => {
                if (row) {
                  const {
                    total = 0,
                    answered = 0,
                    missed = 0,
                    rejected = 0,
                    ivr = 0,
                  } = row || {};
                  return (
                    <TableRow key={key + 1} style={{ whiteSpace: "nowrap" }}>
                      <TableCell component="th" scope="row">
                        {key + 1}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.contactName}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.fromName}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {total}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {answered}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {missed}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {rejected || 0}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Toolbar title="Tỉ lệ trả lời">
                          {`${((answered / total) * 100 || 0).toFixed(2)}%`}
                        </Toolbar>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Toolbar title="Tỉ lệ nhỡ">
                          {`${((missed / total) * 100 || 0).toFixed(2)}%`}
                        </Toolbar>
                      </TableCell>
                    </TableRow>
                  );
                }
              })}
            </TableBody>
          </Table>
        </Paper>
        <Dialog open={loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

ReportCallOutput.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  inboundHours: state.dashboard.inbound,
  contacts: state.dashboard.contact,
  loading: state.dashboard.loading,
});
const NumberConnect = connect(null, phoneNumberAction)(ReportCallOutput);
const Group = connect(null, agentAction)(NumberConnect);
ReportCallOutput = connect(mapStateToProps, mapActionsToProps)(Group);
export default withStyles(styles)(ReportCallOutput);
